import sdkAdapter from './sdkAdapter.js';
import { mainLog } from './logger.js'
import {eventSchemas, propertyMap, attributeToTransfer } from './eventSchemaConfig.js';

let _events = {};
let _events_to_send = {};
let _event_names = {};
let _event_params = {};


const _isBlank = (value) => value === null || value === undefined;

const _deepMerge = (target, source) => {
  const result = { ...target };
  Object.keys(source).forEach((key) => {
    const tVal = result[key];
    const sVal = source[key];

    if (_isBlank(sVal)) return;

    if (
      sVal && typeof sVal === 'object' && !Array.isArray(sVal) &&
      tVal && typeof tVal === 'object' && !Array.isArray(tVal)
    ) {
      result[key] = _deepMerge(tVal, sVal);
    } else {
      result[key] = sVal;
    }
  });
  return result;
};

const _filterBySchema = (eventType, data) => {
  const allowedFields = eventSchemas[eventType];
  if (!allowedFields) return data || {};
  if (allowedFields.length === 0) return {};

  return allowedFields.reduce((acc, key) => {
    if (Object.prototype.hasOwnProperty.call(data, key)) acc[key] = data[key];
    return acc;
  }, {});
};

const addEventName = (eventName) => {
  if (Array.isArray(eventName)) {
    eventName.forEach(event => {
      if (event && typeof event === 'string') {
        _event_names = { ..._event_names, [event]: true };
        _events_to_send = { ..._events_to_send, [event]: true };
      }
    });
  } else if (eventName && typeof eventName === 'string') {
    _event_names = { ..._event_names, [eventName]: true };
    _events_to_send = { ..._events_to_send, [eventName]: true };
  }
};

const getEventsToSend = () => Object.keys(_events_to_send);

const removeEventToSend = (eventName) => {
  delete _events_to_send[eventName];
};

const getEventName = () => Object.keys(_event_names);

const addEventParam = (params) => {
  if (params && typeof params === 'object') {
    _event_params = { ..._event_params, ...params };
  }
};

const getEventParam = () => ({ ..._event_params });

const addEvent = (eventName, data) => {
  if (!eventName) return;

  const safeData = data && typeof data === 'object' ? data : {};

  const filteredData = _filterBySchema(eventName, safeData);
  const isDefinedInSchema = Object.hasOwn(eventSchemas, eventName);

  if (Object.keys(filteredData).length === 0 && !isDefinedInSchema && !_events[eventName]) {
    return;
  }

  _events[eventName] = _deepMerge(_events[eventName] || {}, filteredData);
};

const isEventAlreadySent = (eventName, fillProperties) => {
  //enviar si no ha sido enviado o items cart_update distintos (fillProperties) a lo ya enviado (_events)
  return eventName === 'cart_update' && _events[eventName] !== undefined;
};

const prepareSend = () => {
  const eventsToSend = getEventsToSend();
  const eventsParams = getEventParam();
  const fillProperties = {};

  eventsToSend.forEach(event => {
    const properties = eventSchemas[event];

    if (!properties) {
      if (typeof mainLog === 'function') mainLog(`[trackLayer] The "${event}" schema is not registered.`);
      return;
    }

    const formattedEventParams = rebuildEventParams(eventsParams, properties);

    fillProperties[event] = {};
    const propertyMapByEvent = propertyMap[event] || {};

    properties.forEach(propertyBloomreach => {
      const realProperty = propertyMapByEvent[propertyBloomreach] || propertyBloomreach;

      if (fillProperties[event] &&
          formattedEventParams[realProperty] !== undefined &&
          formattedEventParams[realProperty] !== null
      ) {
        fillProperties[event][propertyBloomreach] = _getFormattedEventParams(event, realProperty, formattedEventParams, propertyMapByEvent);
      }

      if (isEventAlreadySent(event, fillProperties)) {
        mainLog("[trackLayer:EventMerge] no send " + event, _events_to_send);
        delete fillProperties[event];
        removeEventToSend(event);
      }
    });

    if (fillProperties[event] && Object.keys(fillProperties[event]).length === 0 && eventSchemas[event].length > 0) {
      delete fillProperties[event];
    }
  });
  return fillProperties;
};

const _getFormattedEventParams = (event, realProperty, eventParams, propertyMapByEvent = {}) => {

  if (event === 'purchase' && realProperty === 'product_list') {
    return _enrichProductList(eventParams, propertyMapByEvent);
  }
  return eventParams[realProperty];
}

const _enrichProductList = (data, propertyMap = {}) => {

  const fieldsToMerge = attributeToTransfer['product_item'] || [];

  data.product_list = data.product_list.map(item => {
    const enriched = {};
    fieldsToMerge.forEach(key => {
      const mapKey = propertyMap[key] || key;
      enriched[key] = data[mapKey];
    });
    return { ...item, ...enriched };
  });

  return data.product_list;
}

const send = () => {
  if (Object.keys(_events_to_send).length === 0) return;
  mainLog("[trackLayer:EventMerge] send _events_to_send:", _events_to_send);

  const eventsToSend = prepareSend();
  Object.entries(eventsToSend).forEach(([type, data]) => {
    if (type === 'default_properties') {
      return;
    }
    if (sdkAdapter) {
      if (type === 'identify') {
        sdkAdapter.identify(data);
      } else if (type === 'anonymize') {
        sdkAdapter.anonymize();
      } else if (type === 'unknown') {
        sdkAdapter.sendToServer(type, data);
      } else if (type === 'consent') {
        sdkAdapter.sendConsent(type, data);
      } else if (type !== 'default_properties') {
        sdkAdapter.track(type, data);
      }

      removeEventToSend(type);
      mainLog("[trackLayer:EventMerge] Delete the sent event:", _events_to_send);
    } else {
      mainLog("[trackLayer:EventMerge] NO Send:", type);
    }

    addEvent(type, data);
    mainLog("[trackLayer:EventMerge] Send:", type, data);
  });
};

const getAccumulatedEvents = () => ({ ..._events });

const clearAccumulatedEvents = () => {
  _events = {};
};


const rebuildEventParams = (
  flatObject,
  properties = [],
  basePrefix = ['prditem']
) => {
  const targetProperties = properties.filter(prop => prop === 'product_list');

  // Si no hay propiedades objetivo válidas, devuelve una copia superficial del objeto original
  if (targetProperties.length === 0) {
    return { ...flatObject };
  }

  const result = {};
  const itemsMap = {};

  Object.entries(flatObject).forEach(([key, value]) => {

    const matchedPrefix = basePrefix.find(prefix => key.startsWith(prefix));

    if (matchedPrefix) {
      // Extrae la parte tras el prefijo (ej: "1-name" o "1-item_id")
      const rest = key.slice(matchedPrefix.length);
      const dashIndex = rest.indexOf('-');

      if (dashIndex !== -1) {
        const index = rest.slice(0, dashIndex);
        const propName = rest.slice(dashIndex + 1);

        itemsMap[index] ??= {};
        itemsMap[index][propName] = value;
        result[key] = value; //persist param
        return;
      }
    }

    result[key] = value;
  });

  const itemsArray = Object.values(itemsMap);

  targetProperties.forEach(propName => {
    result[propName] = itemsArray;
  });

  return result;
};

const eventMerge = {
  addEvent,
  send,
  getAccumulatedEvents,
  clearAccumulatedEvents,
  _deepMerge,
  _filterBySchema,
  addEventName,
  getEventName,
  getEventsToSend,
  addEventParam,
  getEventParam,
  prepareSend,
  rebuildEventParams
};

// 🌟 EXPORTACIÓN DE VITE: Exportamos por defecto el módulo listo para usar
export default eventMerge;